import * as THREE from 'three'
import React, { Fragment, ReactComponentElement, useEffect, useState } from 'react'
import { Mesh, MeshStandardMaterial, Object3D, PointLight, Vector2, Vector3 } from 'three'
import CharacterConfig from '../../f.assets/Characters/scripts/classes/CharacterConfig'
import replaceStandardByToonMaterial from '../../f.assets/scripts/replaceStandardByToonMaterial'
import { useScripts } from '../../f.assets/scripts/useScripts'
import { Obstacle, Treasure } from '../../e.elements/GameElements/components'
import GameElement from '../../e.elements/GameElements/GameElement/GameElement'
import BasicBooty from '../../e.elements/scenes/SceneDemo/components/BasicBooty'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import { addElementToGrid } from '../TerrainManager/scripts/scripts'
import { COMMANDERS, LevelConfig, Player } from './store.d'
import { coordsToPosition } from '../../e.elements/Grid/scripts/helpers/coordsPositionConverter'
import { Candy, CANDY_TYPES } from '../../f.assets/Objects/components/Candy/Candy'
import { default as CandyClass } from '../../e.elements/GameElements/classes/Candy'
import { Billboard, Sparkles } from '@react-three/drei'
import { LayerMaterial, Depth } from 'lamina'
import Treasures from './Treasures'
import Belligerents from './Belligerents'
import { SEL_GRID_ORIGIN } from '../TerrainManager/selectors'
import Graveyards from '../../e.elements/scenes/Graveyards/Graveyards'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'
import { CHARACTER_TYPES } from '../../f.assets/Characters/scripts/constants'

const pickLampPosts = (callback: (result: ReactComponentElement<any>[]) => void) => (obj: Object3D) => {
  const lamps: Object3D[] = []
  obj.traverse((o: Object3D | Mesh) => {
    if (o.name.includes('lampPost')) {
      o.traverse((oCh: Object3D | Mesh) => {
        const mesh = oCh as Mesh
        const mat = mesh.material as MeshStandardMaterial

        if (mat?.name.includes('Yellow')) {
          lamps.push(mesh)
        }
      })
    }
  })

  const lampColors = [0xff5c33, 0xac3cef]
  callback(
    lamps.map((lamp, idx) => {
      const color = lampColors[idx % lampColors.length]
      const lightPosition = lamp.localToWorld(lamp.position.clone()).add(new Vector3(0, 2.5, 0))
      const sparklesSize = Array.from({ length: 5 }, () => 25 + Math.random() * 20)
      // console.log(lamp.uuid)

      return (
        <Fragment key={`lamp_${lamp.uuid}`}>
          <pointLight args={[color, 5, 17]} position={lightPosition} />
          <Sparkles
            count={5}
            //@ts-ignore
            size={sparklesSize}
            position={lightPosition.clone().add(new Vector3(0, -1, 0))}
            scale={[4, 1.5, 4]}
            speed={0.3}
          />
          <Glow position={lightPosition.clone().add(new Vector3(0, -0.2, 0))} color={color} />
        </Fragment>
      )
    }),
  )
}
const pickTorches = (callback: (result: Object3D[]) => void) => (obj: Object3D) => {
  // const scene = getParentScene(obj)
  const torches: Object3D[] = []
  obj.traverse(o => {
    // console.log(o.name, o.name.includes('torchWall'))

    if (o.name.includes('torchWall')) {
      torches.push(o)
      // const fireLight = new PointLight(0xff7d46, 3, 17)
      // fireLight.position.copy(o.position)
      // fireLight.position.z += 0.5
      // fireLight.position.y += 1
      // scene?.add(fireLight)
      // DEBUG
      // const lightHelpert = new PointLightHelper(fireLight, 1, 0x00ff00)
      // scene?.add(lightHelpert)
    }
  })
  callback(torches)
}
const randomPosition = (obj: Object3D) => {
  if (!obj.userData.oPosition) {
    obj.userData.oPosition = obj.position.clone()
  }
  obj.position.x = Math.sin(Math.random() - 0.5) * 0.25
  obj.position.y = Math.sin(Math.random() - 0.5) * 0.25
}

const LevelManager = ({ levelConfig }: { levelConfig?: LevelConfig }) => {
  const [lamps, setLamps] = useState<ReactComponentElement<any>[]>([])
  const initCharacters = useSceneStore(s => s.characters.initCharacters)
  const setTreasures = useSceneStore(s => s.terrain.setTreasures)
  const setPlayers = useSceneStore(s => s.levels.setPlayers)
  const setManaConfig = useSceneStore(s => s.levels.setManaConfig)
  const gridTiles = useSceneStore(s => s.terrain.data.grid)
  const belligerents = useSceneStore(s => s.levels.data.players)
  const checkForGrid = useSceneStore(s => s.levels.data.checklistToGo.gridElement)
  // the origin of the grid
  const gridOrigin = useSceneStore(SEL_GRID_ORIGIN)

  useEffect(() => {
    if (levelConfig) {
      // initBattleController()

      const caracters = levelConfig.characters.map(
        c =>
          new CharacterConfig({
            coords: new Vector2(c.coords.x, c.coords.y),
            type: c.type,
            owner: c.owner,
            tickDivisions: c.tickDivisions,
            variant: c.variant,
            team: levelConfig.players.find(p => p.id === c.owner)?.team!,
          }),
      )

      initCharacters(caracters)
      setTreasures(levelConfig.treasures)
      const team = useScenesStore.getState().user.team

      setPlayers(levelConfig.players)
      levelConfig.players.forEach((p: Player) => {
        setManaConfig(p.id as COMMANDERS, { manaLevel: p.manaLevel ?? 0, maxManaLevel: p.maxManaLevel ?? 0 })
      })
    }
  }, [levelConfig])

  return (
    <>
      {levelConfig && (
        <GameElement onStart={useScripts([replaceStandardByToonMaterial, pickLampPosts(setLamps)])}>
          <Graveyards id={levelConfig.id} />
        </GameElement>
      )}
      {checkForGrid && <Treasures levelConfig={levelConfig} />}
      {checkForGrid &&
        levelConfig?.obstacles.map((t, idx) => (
          <Obstacle
            key={`tresure_${idx}`}
            onStart={useScripts([/*setRandomPosition,*/ addElementToGrid])}
            userData={{ coords: t.coords }}
          >
            <BasicBooty color={0x0000ff} />
          </Obstacle>
        ))}
      <Belligerents data={belligerents} />
      {checkForGrid &&
        gridTiles
          .flatMap(r => r)
          .map(tile => {
            const gridPos = coordsToPosition(tile.coords, gridOrigin)
            return (
              <GameElement
                elementClass={CandyClass}
                position={gridPos}
                visible={false}
                userData={{ coords: tile.coords }}
                key={`candy_for_${tile.coords.x}_${tile.coords.y}`}
                name={`candy_for_${tile.coords.x}_${tile.coords.y}`}
                onStart={(obj: Object3D) => {
                  obj.rotation.set(0, Math.PI * (Math.random() * 2), 0)
                }}
              >
                <MemoizedCandy />
              </GameElement>
            )
          })}
      {lamps}
    </>
  )
}

export default LevelManager

const MemoizedCandy = React.memo(() => (
  <Candy
    candyType={
      [CANDY_TYPES.CANDYA, CANDY_TYPES.CANDYB, CANDY_TYPES.CANDYC, CANDY_TYPES.CANDYD][Math.floor(Math.random() * 4)]
    }
  />
))
const Glow = ({ position, color }: { position: Vector3; color: number }) => {
  // const color = '#ff9f50' // ''
  const scale = 0.5
  const near = -3
  const far = 1
  return (
    <Billboard position={position}>
      <mesh>
        <circleGeometry args={[2 * scale, 16]} />

        <LayerMaterial
          transparent
          depthWrite={false}
          blending={THREE.CustomBlending}
          blendEquation={THREE.AddEquation}
          blendSrc={THREE.SrcAlphaFactor}
          blendDst={THREE.DstAlphaFactor}
        >
          <Depth
            colorA={color}
            colorB="black"
            alpha={1}
            mode="normal"
            near={near * scale}
            far={far * scale}
            origin={[0, 0, 0]}
          />
          <Depth
            colorA={color}
            colorB="black"
            alpha={0.5}
            mode="add"
            near={-40 * scale}
            far={far * 1.2 * scale}
            origin={[0, 0, 0]}
          />
          <Depth
            colorA={color}
            colorB="black"
            alpha={1}
            mode="add"
            near={-15 * scale}
            far={far * 0.7 * scale}
            origin={[0, 0, 0]}
          />
          <Depth
            colorA={color}
            colorB="black"
            alpha={1}
            mode="add"
            near={-10 * scale}
            far={far * 0.68 * scale}
            origin={[0, 0, 0]}
          />
        </LayerMaterial>
      </mesh>
    </Billboard>
  )
}
